// extracted by mini-css-extract-plugin
module.exports = {"component":"Formatted_component__17AAm","big":"Formatted_big__1xPKE","load":"Formatted_load__15TzG"};